import React from "react";
import { Typography } from "@material-ui/core";

const KbartHelpText = () => {
  return (
    <div>
      <Typography variant="body2">
        To request KBART records for your library catalog, follow these steps:
      </Typography>
      <ol>
        <li>
          <strong>Select the Organization.</strong>
        </li>
        <li>
          <strong>Enter the Email Address:</strong>
        </li>
        <ul>
          <li>
            Type the email address where you'd like to receive the KBART
            records.
          </li>
        </ul>
        <li>
          <strong>Set Optional Date Range:</strong>
        </li>
        <ul>
          <li>
            Fill in the Start Date and End Date fields if you want records
            within a specific timeframe.
          </li>
          <li>
            Leave these fields blank to retrieve records from all available
            dates.
          </li>
        </ul>
        <li>
          <strong>Filter by Content Type:</strong>
        </li>
        <ul>
          <li>
            Choose specific types of content to include (e.g., books, images,
            videos).
          </li>
          <li>No selection means that all content types will be included.</li>
        </ul>
        <li>
          <strong>Limit by Module:</strong>
        </li>
        <ul>
          <li>Select specific modules if you don't want all the records.</li>
          <li>
            Leave this unselected to export KBART records from all modules.
          </li>
        </ul>
        <li>
          <strong>Click Export:</strong>
        </li>
        <ul>
          <li>Click EXPORT to generate the KBART records.</li>
          <li>
            Once the records are ready, they will be sent to the requested email
            address.
          </li>
        </ul>
      </ol>
    </div>
  );
};

export default KbartHelpText;
